<template>
  <footer class="relative border-t border-gray-100 bg-gray-50">
    <button
      v-show="showTop"
      class="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-2 text-[11px] font-semibold text-ink shadow-card transition hover:-translate-y-0.5 hover:border-brand hover:text-brand"
      type="button"
      aria-label="Scroll to top"
      @click="scrollToTop"
    >
      <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 19V5m0 0l-6 6m6-6l6 6" />
      </svg>
      Top
    </button>
    <div class="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-12 md:grid-cols-4 lg:px-8">
      <div>
        <div class="flex items-center gap-3">
          <img src="@/assets/logo.png" alt="Invi8 Logo" style="height:40px">
        </div>
        <p class="mt-4 max-w-xs text-sm text-muted">Invi8 curates trusted vendors and instant invites for every kind of event—with transparent pricing and real reviews.</p>
        <div class="mt-4 flex gap-3 text-muted">
          <a class="rounded-full border border-gray-200 p-2 transition hover:border-brand hover:text-brand" href="#" aria-label="Instagram">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M7 4h10a3 3 0 013 3v10a3 3 0 01-3 3H7a3 3 0 01-3-3V7a3 3 0 013-3z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <circle cx="17.5" cy="6.5" r=".5" />
            </svg>
          </a>
          <a class="rounded-full border border-gray-200 p-2 transition hover:border-brand hover:text-brand" href="#" aria-label="Twitter">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M22 5.8a8.5 8.5 0 01-2.36.65 4.1 4.1 0 001.8-2.27 8.2 8.2 0 01-2.6.97 4.13 4.13 0 00-7.2 2.81c0 .32.04.63.1.93A11.7 11.7 0 013 4.6a4.12 4.12 0 001.28 5.5 4.07 4.07 0 01-1.86-.5v.05a4.14 4.14 0 003.3 4.05 4.2 4.2 0 01-1.85.07 4.14 4.14 0 003.86 2.86A8.3 8.3 0 012 19.54a11.67 11.67 0 006.29 1.84c7.55 0 11.68-6.16 11.68-11.5 0-.18 0-.35-.01-.53A8.2 8.2 0 0022 5.8z" />
            </svg>
          </a>
        </div>
      </div>
      <div>
        <p class="text-sm font-semibold text-ink">Explore</p>
        <ul class="mt-4 space-y-2 text-sm text-muted">
          <li><RouterLink class="transition hover:text-ink" to="/vendors">Find Vendors</RouterLink></li>
          <li><RouterLink class="transition hover:text-ink" to="/use-cases">Use Cases</RouterLink></li>
          <li><RouterLink class="transition hover:text-ink" to="/faqs">FAQs</RouterLink></li>
          <li><RouterLink class="transition hover:text-ink" to="/pricing">Pricing</RouterLink></li>
          <li><RouterLink class="transition hover:text-ink" to="/blog">Inspiration</RouterLink></li>
          <li><RouterLink class="transition hover:text-ink" to="/about">About Invi8</RouterLink></li>
          <li><RouterLink class="transition hover:text-ink" to="/contact">Support</RouterLink></li>
        </ul>
      </div>
      <div>
        <p class="text-sm font-semibold text-ink">Legal</p>
        <ul class="mt-4 space-y-2 text-sm text-muted">
          <li><RouterLink class="transition hover:text-ink" to="/privacy-policy">Privacy Policy</RouterLink></li>
          <li><RouterLink class="transition hover:text-ink" to="/terms">Terms & Conditions</RouterLink></li>
          <li><a class="transition hover:text-ink" href="#">Cookies</a></li>
        </ul>
      </div>
      <div>
        <p class="text-sm font-semibold text-ink">Stay in the know</p>
        <form class="mt-4 space-y-3">
          <label class="sr-only" for="newsletter-email">Email</label>
          <input class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm text-ink placeholder:text-muted focus:border-brand focus:outline-none" type="email" id="newsletter-email" placeholder="you@example.com" />
          <button class="w-full rounded-2xl bg-brand px-4 py-3 text-sm font-semibold text-white shadow-card transition hover:bg-brandDark" type="button">Get updates</button>
        </form>
      </div>
    </div>
    <div class="border-t border-gray-100 bg-white py-6">
      <div class="mx-auto flex max-w-6xl flex-col justify-between gap-4 px-4 text-xs text-muted lg:flex-row lg:px-8 lg:items-center">
        <p>© {{ year }} Invi8. All rights reserved.</p>
        <div class="flex items-center gap-3">
          <RouterLink class="transition hover:text-ink" to="/privacy-policy">Privacy</RouterLink>
          <RouterLink class="transition hover:text-ink" to="/terms">Terms</RouterLink>
          <a class="transition hover:text-ink" href="#">Cookies</a>
          <button
            class="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-2 text-[11px] font-semibold text-ink shadow-card transition hover:-translate-y-0.5 hover:border-brand hover:text-brand"
            type="button"
            aria-label="Scroll to top"
            @click="scrollToTop"
          >
            <svg class="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 19V5m0 0l-6 6m6-6l6 6" />
            </svg>
            Top
          </button>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { RouterLink } from 'vue-router'
import { onMounted, onUnmounted, ref } from 'vue'

const year = new Date().getFullYear()
const showTop = ref(false)
let lastY = 0

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const handleScroll = () => {
  const y = window.scrollY || document.documentElement.scrollTop
  if (y > lastY + 10) {
    showTop.value = true
  } else if (y < lastY - 10) {
    showTop.value = false
  }
  lastY = y
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>
